import type { TokenPackage } from './TokenPackage.model'
import type { CaptchaRequest } from '@/models/Captcha.model'

export interface AuthenticationAttemptRequest {
  login: string
  plainPassword: string
  domain: string
  captcha?: CaptchaRequest
}

export interface AuthenticationAttemptResponse
  extends AuthenticationAttemptRequest {
  succeed: boolean
  authenticatedTokenPackage: TokenPackage
}

export class AuthenticationAttempt implements AuthenticationAttemptRequest {
  login = ''
  plainPassword = ''
  domain = ''
}
